import { render, staticRenderFns } from "./InfoTransacaoPix.vue?vue&type=template&id=7d1d9ffc&scoped=true"
import script from "./InfoTransacaoPix.vue?vue&type=script&lang=js"
export * from "./InfoTransacaoPix.vue?vue&type=script&lang=js"
import style0 from "./InfoTransacaoPix.vue?vue&type=style&index=0&id=7d1d9ffc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d1d9ffc",
  null
  
)

export default component.exports